<template>
  <div id="app" class="font-neue-light">
    <!--
    <a href="https://wa.link/oxfsnb" target="_blank" clas="icon__container">
      <div
        class="icon__container icon__circle bg-green-neon flex justify-center items-center cursor-pointer"
      >
        <img src="/img/icons/whatsapp_purple.png" alt="wsp" width="32" />
      </div>
    </a>
    -->

    <router-view v-if="services" />
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  name: "App",
  mounted() {
    this.$store.dispatch("business/load");
    const loader = document.querySelector(".loader");
    loader.style.opacity = 0;
    setTimeout(() => {
      this.$el.style.opacity = 1;
      loader.style.display = "none";
    }, 800);
  },
  computed: {
    ...mapState("business", {
      services: (state) => state.services,
    }),
  },
};
</script>

<style lang="scss">
@import "./scss/main.scss";

.icon__circle {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  z-index: 4;
}

.icon__container {
  position: fixed;
  bottom: 2.5rem;
  right: 2.5rem;

  @media only screen and (max-width: 992px) {
    bottom: 1rem;
    right: 1rem;
  }
}
</style>
